import script from "./addNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./addNotice.vue?vue&type=script&setup=true&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=6b39b621&lang=less"

const __exports__ = script;

export default __exports__